export const CHECKOUT_URL = 'https://modulation-en.impultienda.ar/checkout/';

export const IMAGES = {
  mockup: 'https://cdn.magicpatterns.com/uploads/esa1wTC4TzcwTXhiUiUjHp/MODULATION-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/1M4eaUHM5xHcXz4zuoi1qs/DR._ELOWEN_VARELLI_-_SENSORY.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/scgAHxiDKnuYtaNbs3csxw/BONUS_1_MODULATION-EN.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/k3WUEMUXg38zsTcraRML5w/BONUS_2_MODULATION-EN.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/634E7PeesSHQrt8x4B25Ua/BONUS_3_MODULATION-EN.png',
  bonus4: 'https://cdn.magicpatterns.com/uploads/o8EF966exPPZ94FCg32nuK/BONUS_4_MODULATION-EN.png',
  bonus5: 'https://cdn.magicpatterns.com/uploads/5K9RGC6akRb65L8k6mDvaR/BONUS_5_MODULATION-EN.png',
};
